<div class="st-attachments-list-items-container">
    <!-- @for (group of groupedAttachmentPoolItems(); track group) {
        @if (group.items?.length) {
            <div class="st-attachments-list-items-group">
                <div class="st-attachments-list-items-group__header">
                    <mat-icon fontSet="material-symbols-outlined">
                        {{ group.icon }}
                    </mat-icon>
                    <div class="st-attachments-list-items-group__header-title">
                        {{ group.label }}
                    </div>
                </div>
                <div class="st-attachments-list-items-group__items">
                    @for (attachment of group.items; track attachment?.guid) {
                        <st-attachments-list-item
                            [attachment]="attachment"
                            (openAttachment)="openAttachment($event)" />
                    }
                </div>
            </div>
        }
    } -->

    @for (group of groupedAttachmentPoolItems(); track group.id) {
        @if (group.items?.length) {
            <div class="st-attachments-list-items-group">
                <div class="st-attachments-list-items-group__header">
                    <mat-icon fontSet="material-symbols-outlined">
                        {{ group.icon }}
                    </mat-icon>
                    <div class="st-attachments-list-items-group__header-title">
                        {{ group.label }}
                    </div>
                </div>
                <div class="st-attachments-list-items-group__items">
                    @for (attachment of group.items; track attachmentTrackBy(attachment)) {
                        @if (attachment.attachmentType === 'mirAttachment') {
                            <st-attachments-list-item
                                [attachment]="attachment"
                                [data]="record()"
                                (openAttachment)="openMIRAttachment($event)" />
                        }
                        @if (attachment.attachmentType === 'attachmentPoolItem') {
                            <div
                                class="st-attachments-list-item"
                                draggable="true"
                                (click)="openAttachment(attachment)"
                                (dragstart)="dragStart($event, attachment)">
                                <div class="st-attachments-list-item-file-header">
                                    <mat-icon fontSet="material-symbols-outlined">
                                        @switch (attachment?.TagType) {
                                            @case (MediaTagTypes.IMAGE) {
                                                image
                                            }
                                            @case (MediaTagTypes.VIDEO) {
                                                video_file
                                            }
                                            @case (MediaTagTypes.AUDIO) {
                                                audio_file
                                            }
                                        }
                                    </mat-icon>
                                    <div
                                        class="st-attachments-list-item-file-header__title"
                                        [matTooltip]="attachment?.Name">
                                        {{ attachment?.Name }}
                                    </div>
                                    <st-external-actions-overlay
                                        isAttachmentPoolItem
                                        editable
                                        [disabled]="disabled()"
                                        [attachmentPoolItemData]="attachment"
                                        [data]="record()" />
                                </div>
                                <div class="st-attachments-list-item-file-container">
                                    @switch (attachment?.TagType) {
                                        @case (MediaTagTypes.IMAGE) {
                                            <img
                                                class="st-attachments-list-item__img"
                                                fill
                                                [ngSrc]="attachment?.Url" />
                                        }
                                        @case (MediaTagTypes.VIDEO) {
                                            <video
                                                class="st-attachments-list-item__video"
                                                [src]="attachment?.Url"></video>
                                        }
                                        @case (MediaTagTypes.AUDIO) {
                                            <audio
                                                controls
                                                class="st-attachments-list-item__audio"
                                                controlsList="noplaybackrate nodownload">
                                                <source [src]="attachment?.Url" />
                                            </audio>
                                        }
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        }
    }
</div>

@if (linkedRecords()?.length) {
    <mat-chip-listbox>
        @for (item of linkedRecords(); track item?.Guid) {
            <mat-chip
                removable
                (click)="openLinkedRecord(item)">
                <mat-icon>satellite_alt</mat-icon>
                {{ item?.Title }}
            </mat-chip>
        }
    </mat-chip-listbox>
}

<!-- Left for future use, for now we support only MIR attachments from placeholders and no attachments upload -->
@if (!isAndroidWrapper() && editable()) {
    <div
        class="st-attachments-list-upload"
        ngFileDrop
        [class.st-attachments-list-upload--dragging]="dragOver()"
        (uploadOutput)="onUploadOutput($event)">
        <span>{{ languageSettings.PSTWebAttachmentsListDragFile }}</span>
        <button
            class="st-attachments-list-upload-browse"
            [disabled]="disabled()"
            (click)="browse()">
            {{ languageSettings.PSTWebBrowseButtonLabel }}
        </button>
        <input
            #file
            type="file"
            ngFileSelect
            [disabled]="disabled()"
            [hidden]="true"
            (uploadOutput)="onUploadOutput($event)" />
    </div>
}

<!-- TODO: responsive -->
<!-- <div class="st-attachments-list-upload"
     *ngIf="isAndroidWrapper && editable"
     (click)="fireUploadEvent($event)">
    <label [attr.for]="(id ? id + 'FileInput' : null)">
        <span class="left pointer icon-Add mleft20"></span>
    </label>
    <input #attachment
           [attr.id]="(id ? id + 'FileInput' : null)"
           multiple="multiple"
           class="upload-file pointer"
           type="file" />
</div> -->
